// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-form-group {\n  padding: 0 0 16px !important;\n}\n.emd-form-group .emd-input-link {\n  margin-top: 4px !important;\n}\n.emd-label {\n  margin-bottom: 2px !important;\n  text-transform: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
